export const optionsTexts = [
  "ApplicationLookups",
  "Permission",
  "UserGroupPermissions",
  "DynamicLanguage",
  "Customer",
  "SystemAppForms",
  "Backups",
  "Scheduler",
  "MoveAssets",
  "RemoveHOS",
  "EventTriggers",
  "CacheList",
];



// WEBPACK FOOTER //
// ./src/components/diagnostics/options.js